import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export function CoworldVersionNavigation({
  section,
  runsHref,
  checksHref,
}: Readonly<{
  section: "runs" | "checks";
  runsHref: string;
  checksHref: string;
}>) {
  return (
    <nav aria-label="Coworld version" {...stylex.props(styles.navigation)}>
      <a
        href={runsHref}
        aria-current={section === "runs" ? "page" : undefined}
        {...stylex.props(styles.tab, section === "runs" && styles.selected)}
      >
        Runs
      </a>
      <a
        href={checksHref}
        aria-current={section === "checks" ? "page" : undefined}
        {...stylex.props(styles.tab, section === "checks" && styles.selected)}
      >
        Checks
      </a>
    </nav>
  );
}
const styles = stylex.create({
  navigation: {
    display: "flex",
    gap: spacing.space24,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: colors.hairline,
    marginBottom: spacing.space16,
  },
  tab: {
    paddingBlock: spacing.space12,
    color: colors.secondary,
    fontSize: fontSizes.label,
    textDecoration: "none",
    borderBottomWidth: 2,
    borderBottomStyle: "solid",
    borderBottomColor: "transparent",
    outlineColor: colors.foreground,
  },
  selected: {
    color: colors.foreground,
    borderBottomColor: colors.foreground,
    fontWeight: 500,
  },
});
